import VueHtmlToPaper from 'vue-html-to-paper';


/*
Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
 */
export default defineNuxtPlugin((nuxtApp) => {
    const options = {
        name: '_blank',
        specs: [
          'fullscreen=no',
          'titlebar=yes',
          'scrollbars=yes'
        ],
        styles: [
          'https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css',
          '/assets/css/ingresso.css'
        ]
      }

    nuxtApp.vueApp.use(VueHtmlToPaper, options);
});
